import { Flex } from "@chakra-ui/react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RemoteRenderingBackchannel } from "../../../pages";

const remoteRenderingBackchannelQueryParamsSchema = z.object({
  // Any URI scheme is allowed: the callback is opened on the remote machine and
  // native apps there register custom schemes (e.g. `myapp://callback`).
  // `catch` keeps a malformed value out of the search error boundary so the page
  // can render its own "no valid redirect_uri" message instead.
  redirect_uri: z.url().optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_authenticated/session/remote-rendering-node-backchannel",
)({
  component: () => (
    <Flex flexGrow={1} alignSelf={"center"} alignItems={"center"}>
      <RemoteRenderingBackchannel />
    </Flex>
  ),
  validateSearch: remoteRenderingBackchannelQueryParamsSchema,
});
